module.exports = "<dt-content-header state-title=\"'Sensors & Connectors'\"></dt-content-header> <dt-sensor-tabs tab-id=$ctrl.tabId search-query=$ctrl.q></dt-sensor-tabs> <ui-view search-query=$ctrl.q></ui-view>";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/sensors.html
// module id = zwEQ
// module chunks = 1